import { render, staticRenderFns } from "./ToProcessFiles.vue?vue&type=template&id=6da56788&scoped=true"
import script from "./ToProcessFiles.vue?vue&type=script&lang=ts"
export * from "./ToProcessFiles.vue?vue&type=script&lang=ts"
import style0 from "./ToProcessFiles.vue?vue&type=style&index=0&id=6da56788&lang=scss&scoped=true"
import style1 from "./ToProcessFiles.vue?vue&type=style&index=1&id=6da56788&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da56788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da56788')) {
      api.createRecord('6da56788', component.options)
    } else {
      api.reload('6da56788', component.options)
    }
    module.hot.accept("./ToProcessFiles.vue?vue&type=template&id=6da56788&scoped=true", function () {
      api.rerender('6da56788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/ToProcessFiles.vue"
export default component.exports